module.exports = __webpack_public_path__ + "static/media/218-Milo-Fragen_ID_4.1fa9fea0.mp3";